import React from "react";
import AddLanguageWizardStore from "../../../stores/add-language-wizard-store";
import AddLanguageWizardStepTitle from "../add-language-wizard-step-title";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import IconFile from "../../../../../components/icons/icon-file/icon-file";
import localesListStore from "../../../stores/locales-list-store";
import { Button } from "../../../../../components/inputs/button/button";

interface IProps {
    wizardStore: AddLanguageWizardStore;
}

const DownloadTranslationsStep: React.FC<IProps> = ({ wizardStore }) => {
    return (
        <>
            <AddLanguageWizardStepTitle
                title={"Second Step: Download and Prepare the Translation File"}
                subtitle={"Download the CSV template containing all text fields that need translation. Then, open the file and add translations for your selected language, keeping the same structure."}
            />
            <div>
                <Button text="DOWNLOAD CURRENT CSV" 
                    variant={BUTTON_VARIANTS.Secondary} 
                    leftIcon={IconFile} 
                    onClick={localesListStore.downloadTranslations}
                    isLoading={localesListStore.isDownloading()}
                    hasLoader={true}
                    disabled={localesListStore.isDownloading()}
                />
            </div>
        </>
    );
}

export default DownloadTranslationsStep;